import { render } from "./TelegramDigestCard.vue?vue&type=template&id=745c9574"
import script from "./TelegramDigestCard.vue?vue&type=script&lang=js"
export * from "./TelegramDigestCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__